import { registerEditorAction, registerEditorContribution } from '../../../browser/editorExtensions.js';
import { HoverParticipantRegistry } from '../../hover/browser/hoverTypes.js';
import { AcceptInlineEdit, RejectInlineEdit, JumpToInlineEdit, JumpBackInlineEdit, TriggerInlineEdit } from './commands.js';
import { InlineEditHoverParticipant } from './hoverParticipant.js';
import { InlineEditController } from './inlineEditController.js';
registerEditorAction(AcceptInlineEdit);
registerEditorAction(RejectInlineEdit);
registerEditorAction(JumpToInlineEdit);
registerEditorAction(JumpBackInlineEdit);
registerEditorAction(TriggerInlineEdit);
registerEditorContribution(InlineEditController.ID, InlineEditController, 3 );
HoverParticipantRegistry.register(InlineEditHoverParticipant);
